export const Supported_language=[
    {identifier:"en",name:"EN"},
    {identifier:"dk",name:"DK"}
]